// Anything below 650px will trigger mobile mode
export const MOBILE_MODE_WIDTH_THRESHOLD = 650;
